import React from "react";
import { Lock } from "lucide-react";

import DashboardLayout from "src/components/layout/dashboard/Layout";
import Card from "src/components/common/card/Card";
import CardHeader from "src/components/common/card/CardHeader";
import ResetPasswordCard from "src/components/cards/ResetPasswordCard";

const SettingsPasswordPage: React.FC = () => {
  return (
    <DashboardLayout
      meta={{
        title: "Password | Invyntra",
        description: "Change your account password.",
        keywords: "password, security, settings, invyntra",
      }}
    >
      <div className="mx-auto max-w-xl space-y-4">
        <div className="flex items-start gap-4">
          <div className="flex h-14 w-14 shrink-0 items-center justify-center rounded-2xl bg-primary-100 text-primary-600 dark:bg-primary-900/40 dark:text-primary-300">
            <Lock size={26} />
          </div>
          <div>
            <h1 className="text-2xl font-bold text-gray-900 dark:text-gray-100">
              Password
            </h1>
            <p className="text-sm text-gray-500 dark:text-gray-400">
              Update the password used to sign in to your account.
            </p>
          </div>
        </div>

        <Card>
          <CardHeader title="Change password" />
          <ResetPasswordCard />
        </Card>
      </div>
    </DashboardLayout>
  );
};

export default SettingsPasswordPage;
